import React, { FC } from 'react';
import { Platform } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { Box } from '@fhs-legacy/universal-components';
import { STORE_LOCATOR_CONTAINER } from 'utils/test-ids';

import { ItemsUnavailableDialog } from './items-unavailable-dialog';
import { StoreLocatorProvider, useStoreLocatorContext } from './store-locator-provider';
import { StoreLocatorView } from './store-locator.view';

/**
 *
 * StoreLocator purpose
 *
 */
const StoreLocator: FC<React.PropsWithChildren<unknown>> = () => {
  const context = useStoreLocatorContext();
  const hasStoreLocatorProvider = Object.keys(context).length > 0;
  const content = (
    <SafeAreaView edges={Platform.OS === 'android' ? ['bottom'] : []} style={{ flex: 1 }}>
      <Box flex={1} testID={STORE_LOCATOR_CONTAINER}>
        <StoreLocatorView />
        <ItemsUnavailableDialog />
      </Box>
    </SafeAreaView>
  );

  return hasStoreLocatorProvider ? (
    content
  ) : (
    <StoreLocatorProvider>{content}</StoreLocatorProvider>
  );
};

export default StoreLocator;
